<template>
  <div class="repayment">
    <div class="navbar_style" :class="$store.state.user.isNested && 'navbar_style_nested'">
      <Icon
        class="navbar_icon"
        name="arrow-left"
        @click="
          $router.push({ path: '/detail', query: { busiId: payInfo.busiId } })
        "
      />
      <span>{{ l.bank_pay_immediately }}</span>
      <div class="icon_box"></div>
    </div>
    <div class="container height_min_vh100">
      <div class="box_sizing_border_box" style="padding: 30px 20px;">
        <div class="repayment_title">
          oxPay
        </div>
        <div class="repayment_info_box">
          <div class="repayment_info_header">
            <img
              src="@/assets/payChoess/card.png"
              alt=""
              style="width: 24px; height: 24px; margin-right: 5px;"
            />
            <div>Quầy thanh toán</div>
          </div>
          <div class="repayment_info_amount">
            <div class="repayment_info_amount_title">Số tiền thanh toán:</div>
            <div class="repayment_info_amount_text">
              VND {{ resData.amount }}
              <img
                @click="onCopy(resData.amount)"
                class="copyIcon"
                src="@/assets/payChoess/copy.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="dynamicTime">
          <!-- 11 : 02 : 06 -->
        </div>
        <div class="repayment_content_nick">
          Transfer
        </div>
        <div class="repayment_content_box">
          <div class="repayment_content_item" style="margin-bottom: 5px;">
            <div class="repayment_content_title">ngân hàng:</div>
            <div class="repayment_content_detail">
              <div>{{ resData.bank_name }}</div>
              <img
                @click="onCopy(resData.bank_name)"
                class="copyIcon"
                src="@/assets/payChoess/copy.png"
                alt=""
              />
            </div>
          </div>
          <div class="repayment_content_item">
            <div class="repayment_content_title">Tài khoản nhờ thu:</div>
            <div class="repayment_content_detail">
              <div>{{ resData.va }}</div>
              <img
                @click="onCopy(resData.va)"
                class="copyIcon"
                src="@/assets/payChoess/copy.png"
                alt=""
              />
            </div>
          </div>
          <div class="repayment_content_item">
            <div class="repayment_content_title">tên chủ thẻ:</div>
            <div class="repayment_content_detail">
              <div>{{ resData.account_name }}</div>
              <img
                @click="onCopy(resData.account_name)"
                class="copyIcon"
                src="@/assets/payChoess/copy.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div v-if="resData.guide_url" class="repayment_content_img_box">
          <img class="repayment_content_img" :src="resData.guide_url" />
        </div>
        <div class="repayment_step_box">
          <div class="repayment_step_title">bước 1:</div>
          <div class="repayment_step_text">
            Sau khi có tài khoản thanh toán, bạn có thể thanh toán vào số thẻ
            của mình bằng chuyển khoản ngân hàng, chuyển khoản ngân hàng trực
            tuyến hoặc bất kỳ hình thức chuyển khoản nào khác
          </div>
        </div>
        <div class="repayment_step_box">
          <div class="repayment_step_title">bước 2:</div>
          <div class="repayment_step_text">
            Tốt nhất nên chọn dịch vụ thanh toán 7/24 để đảm bảo nhận hàng kịp
            thời
          </div>
        </div>
        <div class="repayment_step_box">
          <div class="repayment_step_title">bước 3:</div>
          <div class="repayment_step_text">
            Nếu bạn đã thanh toán nhưng hệ thống không nhận được, vui lòng tham
            khảo ý kiến ngân hàng thanh toán của bạn trước
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon, Toast } from "vant";
import { getva } from "@/services/order";
import l from "@/locales";
export default {
  name: "repayment",
  data() {
    return {
      resData: {},

      androidData: {},

      email: undefined,
      amount: undefined,
      key: undefined,
      contractCode: undefined,
      orderId: undefined,
      l: l.repayMethods,

      isCallback: -1,

      ref: undefined,
      payInfo: {},
    };
  },
  components: { Icon },
  created() {
    this.init(JSON.parse(localStorage.getItem("androidData") || "{}"));
    this.payInfo = JSON.parse(localStorage.getItem("payInfo") || "{}");
  },
  methods: {
    back() {
      window["FlutterClose"].postMessage("hello");
    },
    onCopy(str) {
      let url = str;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      document.execCommand("Copy"); // 执行浏览器复制命令
      Toast("Sao chép thành công!");
      oInput.remove();
    },
    init(data) {
      let that = this;
      // 接收安卓传参
      console.log("安卓已调config");
      // document.getElementById("log_msg").innerHTML += ("<br\>Android调用了js函数并传递参数：" + data);
      if (typeof data == "string") {
        data = JSON.parse(data);
      }

      console.log("安卓已调config2", data);

      that.androidData = data;
      
      let list = [];
      if (data.repayOnline) {
        list.push({ title: "Online Repayment", otc: 2 });
      }
      if (data.repayOffline) {
        list.push({ title: "Offline Repayment", otc: 3 });
      }
      that.headerList = list;
      that.curItem = list[0];

      that.isRollover = data.vaType == 2;
      console.log("that.isRollover", that.isRollover);
      getva({
        ...data,
        atm_otc: 1,
        vaType: 1,
        application_id: data.busiNo,
        timestamp: Date.now(),
        repayChannel: "oxPay",
      }).then((res) => {
        if (res.message) {
          Toast(res.message, 2000);
        }
        that.resData = res.result;
        console.log("that.resData", that.resData);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.repayment {
  min-height: 100vh;
  // padding-top: 50px;
  background: linear-gradient(180deg, #22E72A 0%, #45A1FF 100%);
  box-sizing: border-box;
  .copyIcon {
    width: 22px;
    height: 22px;
    margin-left: 3px;
  }
  .repayment_title {
    font-size: 22px;
    font-weight: bold;
    margin-left: 5px;
    text-align: center;
  }
  .repayment_info_box {
    background: linear-gradient(90deg, #7e90e7 0%, #204ad4 100%);
    width: 100%;
    box-sizing: border-box;
    border-radius: 8px;
    margin-top: 30px;
    .repayment_info_header {
      display: flex;
      align-items: center;
      padding: 10px 15px;
      box-sizing: border-box;
      border-bottom: 1px solid #fff;
    }
    .repayment_info_amount {
      padding: 20px;
      .repayment_info_amount_title {
        text-align: center;
        margin-bottom: 5px;
      }
      .repayment_info_amount_text {
        text-align: center;
        font-size: 30px;
        color: #fff;
        margin: 0;
        font-weight: 700;
      }
    }
  }
  .dynamicTime {
    text-align: center;
    font-size: 30px;
    font-weight: 500;
    margin-bottom: 0px;
    margin-top: 15px;
    color: red;
  }

  .repayment_content_nick {
    text-align: left;
    font-size: 20px;
    margin: 5px;
  }

  .repayment_content_box {
    display: flex;
    flex-direction: column;
    border: 1px solid #fff;
    border-radius: 5px;
    padding: 8px 15px;
    .repayment_content_item {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      color: #e91e07;
      flex-wrap: wrap;
      .repayment_content_title {
        font-size: 18px;
      }
      .repayment_content_detail {
        display: flex;
        flex-direction: row;
        align-items: center;
      }
    }
  }
  .repayment_content_img_box {
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    .repayment_content_img {
      width: 80%;
    }
  }

  .repayment_step_box {
    border: 1px solid #fff;
    border-radius: 5px;
    padding: 8px 15px;
    text-align: left;
    font-size: 18px;
    margin: 12px 0 5px;
    .repayment_step_title {
      font-weight: 700;
      color: #fff;
      margin: 0;
    }
    .repayment_step_text {
      font-size: 16px;
      color: #fff;
      margin: 0;
    }
  }
}
</style>
